import supabase from '../supabase/supabase';

const SESSION_KEY = 'darshana-session-id';

function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export async function trackSiteVisit(pagePath) {
  try {
    await supabase.from('site_visits_1750000013').insert({
      session_id: getSessionId(),
      page_path: pagePath || window.location.hash.replace('#', '') || '/',
      referrer: document.referrer || '',
      user_agent: navigator.userAgent || '',
      country: ''
    });
  } catch (err) {
    console.warn('Site visit tracking failed', err);
  }
}

export async function trackEvent(eventType, metadata = {}) {
  try {
    await supabase.from('analytics_events_1750000001').insert({
      event_type: eventType,
      product_id: metadata.product_id || null,
      metadata
    });
  } catch (err) {
    console.warn('Event tracking failed', err);
  }
}

export function trackPageView(pagePath) {
  trackEvent('page_view', { page: pagePath });
}

export function trackAddToCart(productId, productName) {
  trackEvent('add_to_cart', { product_id: productId, product_name: productName });
}

export function trackPurchase(orderId, totalAmount) {
  trackEvent('purchase', { order_id: orderId, total_amount: totalAmount });
}